import { useEffect, useState, useCallback } from 'react';
import { auth, googleProvider } from '../firebase';
import { onAuthStateChanged, createUserWithEmailAndPassword, signOut, sendPasswordResetEmail, signInWithPopup, updateProfile } from 'firebase/auth';
import { sendVerificationEmail } from '../services/authEmailService';
import { signInWithEmail, clearMfaVerified, clearActiveMfaSession } from '../services/mfaAuth';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const login = useCallback(async (email, password) => {
    const result = await signInWithEmail(email, password);
    if (result.mfaRequired) {
      const err = new Error('MFA_REQUIRED');
      err.code = 'auth/multi-factor-auth-required';
      throw err;
    }
    return result.user;
  }, []);
  const loginWithGoogle = useCallback(() => signInWithPopup(auth, googleProvider), []);
  const register = useCallback(async (email, password, displayName) => {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    if (displayName) await updateProfile(cred.user, { displayName });
    await sendVerificationEmail(cred.user, '/league');
    return cred;
  }, []);
  const resetPassword = useCallback((email) => sendPasswordResetEmail(auth, email), []);
  const logout = useCallback(async () => {
    clearMfaVerified();
    clearActiveMfaSession();
    await signOut(auth);
  }, []);

  return { user, loading, login, loginWithGoogle, register, resetPassword, logout };
}




